export default __webpack_public_path__ + "static/media/04_05.34605cec.jpg";